module.exports = __webpack_public_path__ + "assets/img/landowners.0e711d60.jpg";